export default __webpack_public_path__ + "static/media/water_pump.e777d757.jpg";